<script>
import { forklift_img_v2, forklift_img } from "@/util/config.js";
import { dealTonnageName, dealRiseName } from "@/util/util.js";
export default {
  props: {
    car: {
      type: Object,
      default: () => {
        return {}
      }
    },
    img_size: {
      type: String,
      default: '87px'
    },
  },
  data() {
    return {
      forklift_img_v2,
      forklift_img,
      dealTonnageName,
      dealRiseName
    };
  },
  computed: {
    // 标签信息
    new_title() {
      if (!this.car.new_title) return {}
      return this.car.new_title
    },

  }
};
</script>
<template>
  <div class="car_list_item">
    <div class="car_img" :style="{ width: img_size, height: img_size }">
      <el-image :src="car.product_image_url" fit="cover"></el-image>
    </div>
    <div class="car_params" :style="{minHeight: img_size}">
      <div class="car_title row2">[{{car.city_name}}] {{ new_title.brand}}{{ new_title.model}}</div>
      <div class="params_item">
        <div class="params_item_title">额定载重：</div>
        <div class="params_item_content">{{ dealTonnageName(new_title.tonnage) }}</div>
      </div>
      <div class="params_item">
        <div class="params_item_title">升高门架：</div>
        <div class="params_item_content">{{ dealRiseName(new_title.rise)}}{{ new_title.gantry}}</div>
      </div>
      <div class="params_item">
        <div class="params_item_title">产品类型：</div>
        <div class="params_item_content">{{ new_title.type }}</div>
      </div>
      <div class="params_item">
        <div class="params_item_title">出厂年份：</div>
        <div class="params_item_content">{{ new_title.year }}年</div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.car_list_item {
  display: flex;
  align-items: flex-start;
  &:hover{
    background-color: #f7f8fb;
    cursor: pointer;
  }
  .car_img{
    border-radius: 5px;
    overflow: hidden;
    .el-image{
      width: 100%;
      height: 100%;
    }
  }
  .car_params{
    margin-left: 6px;
    max-width: 160px;
    width: fit-content;
    .car_title{
      width: 100%;
      font-size: 14px;
      color: #1A1A1A;
      line-height: 20px;
      text-align: left;
    }
    .params_item{
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      line-height: 17px;
      color: #838B9F;
      font-size: 12px;
      white-space: nowrap;
    }
  }
}
</style>
